import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Step 4 – Take action!</div>
                                            <p>Doing nothing is often counterproductive, because the longer you
                                                do nothing the more your fears
                                                take root and grow! Think, instead, of the positives that will
                                                result from each small decision or
                                                step you take, and what you will gain or learn from them. If
                                                you’re still convinced some of your
                                                fears are justified, remember that there is more than one way to
                                                achieve anything – get creative.
                                                Having alternative strategies will give you confidence.</p>
                                            <div
                                                className="lightgreencontentbg keyquestionpad uiheading greennumberroundbg1">
                                                <p>If you can, it’s often useful to involve others, if only to
                                                    sound out your ideas or put your fears
                                                    into perspective.</p>
                                            </div>
                                            <br/>
                                            <div className="circle_title-first"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>LACK OF INTEREST
                                            </div>

                                            <div className="border_subtitle">Step 1 – What motivates you?
                                            </div>
                                            <p>Each of us is motivated by different things. You may be
                                                surprised by research which reveals that
                                                the opportunity to learn frequently motivates people more
                                                than money. So, what motivates you or
                                                your colleagues, which could relate to the current
                                                situation? Suggesting what people may achieve
                                                personally will often spur them into action.</p>
                                            <div className="border_subtitle">Step 2 – Appreciate the bigger
                                                picture
                                            </div>
                                            <p>The task you or others have been avoiding might seem mundane
                                                or unrewarding, but have far reaching
                                                overall impact. Recognising how a single issue or task
                                                dovetails into a ‘bigger picture’
                                                can re-ignite flagging interest.</p>
                                            <div className="border_subtitle">Step 3 – The ‘Psychological
                                                contract’
                                            </div>

                                            <p>This is the implicit understanding and trust between people
                                                engaged in fulfilling objectives or
                                                tasks together, or between those who give instructions and
                                                others who carry them out. Unlike a
                                                legal contract, it’s unwritten and usually unspoken, yet
                                                understood and expected by those
                                                involved. It accounts for the kind of things we all do (or
                                                don’t do!) in the workplace and elsewhere,
                                                which aren’t detailed in job descriptions, but to which we
                                                ‘psychologically contract’, as members
                                                of a larger group or organisation. (For example, checking
                                                the office building’s secure when you’re
                                                last to leave is something you might do, even though you’re
                                                not the caretaker, it’s a pain to do and
                                                you’re already late, anyway.)
                                            </p>
                                            <div className="border_subtitle">Step 4 – Be the benchmark for
                                                others
                                            </div>
                                            <p>They don’t, so why should I? An organisation’s ethos or
                                                ‘culture’ is determined less by its policies
                                                and procedures than by the behaviour of its employees. It
                                                only takes the example of a single
                                                individual to influence many others.</p>
                                            <p>Remember, the tool ‘How to motivate others’ might help you to
                                                identify what motivates you.</p>
                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>LACK OF TIME
                                            </div>
                                            <div className="border_subtitle">Step 1 – What is there to do?
                                            </div>
                                            <p>Write it down, all of it. Simple, but best. This way, your
                                                mind stops buzzing and you can finally hear
                                                yourself think. Not only does it look less than you were
                                                imagining or trying to remember, but you’ll
                                                find you’ll start coming up with the ‘how to’s’ as you list
                                                and define things.</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}